export const CONCILIATED = {
  FETCH: "CONCILIATED.FETCH",
  FETCH_SUCCESS: "CONCILIATED.FETCH_SUCCESS",
  FETCH_ERROR: "CONCILIATED.FETCH_ERROR",
  GET_ITEMS: "CONCILIATED.GET_ITEMS",
  GET_ITEMS_SUCCESS: "CONCILIATED.GET_ITEMS_SUCCESS",
  GET_ITEMS_ERROR: "CONCILIATED.GET_ITEMS_ERROR",
  SET_FILTER: "CONCILIATED.SET_FILTER",
  SET_PAGE_INDEX: "CONCILIATED.SET_PAGE_INDEX"
};

export default CONCILIATED;
